import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 12, fill: "currentColor" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M19 11.45a.35.35 0 1 1-.7 0c0-2.9-2.35-5.25-5.25-5.25a.35.35 0 1 1 0-.7A5.95 5.95 0 0 1 19 11.45m-2.66 7.067c-.74.404-1.622.556-2.547.45-1.074-.121-2.182-.553-3.278-1.258a11.3 11.3 0 0 1-2.04-1.669c-1.098-1.055-1.956-2.285-2.47-3.56-.604-1.494-.677-2.878-.16-4.042.315-.71.835-1.293 1.712-1.964l.02-.016.05-.043c.243-.213.375-.299.583-.364a1.17 1.17 0 0 1 .805.046c.37.154.692.44 1.01.87.205.279.367.58.564 1.036l.022.051.023.052c.227.523.301.788.304 1.142.003.417-.148.772-.453 1.09l-.119.121a4 4 0 0 0-.405.448 2.65 2.65 0 0 0-.515 1.516 2.74 2.74 0 0 0 .724 1.887c.817.78 2.139.986 3.082.483.191-.102.38-.251.578-.46.027-.027.054-.057.1-.108l.04-.046c.18-.205.282-.305.424-.406.36-.256.792-.318 1.276-.21.244.053.485.143.8.294.064.03.121.058.257.125a4.4 4.4 0 0 1 1.084.722c.505.469.72.841.685 1.326-.021.31-.128.513-.403.83l-.027.032c-.22.3-.43.538-.825.937a3.9 3.9 0 0 1-.9.688m.21-6.717a.35.35 0 0 0 .35-.35 3.85 3.85 0 0 0-3.85-3.85.35.35 0 1 0 0 .7 3.15 3.15 0 0 1 3.15 3.15c0 .193.157.35.35.35",
      clipRule: "evenodd"
    }
  )
);
var SvgCircledPhoneCallingFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CircledPhoneCallingFilled_default = SvgCircledPhoneCallingFilled;

export { CircledPhoneCallingFilled_default as default };
